import './index.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { LicenseInfo } from '@mui/x-license-pro'

import App from './App'

LicenseInfo.setLicenseKey("829e702c911dfec5f26dcb47806cb208Tz02NDczNCxFPTE3MTM0NTY0NjQ5MjksUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y")

const root = createRoot(
  document.getElementById('root')
)
root.render(
  <App />
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
